
import React, { createContext, useContext, useEffect, useState } from 'react';

import toast from "react-hot-toast"

const AuthContext = createContext();

const apiUrl = process.env.REACT_APP_API_URL 

const seckey = process.env.REACT_APP_REV_KEY;

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [enterOtp , setEnterotp] = useState(null);


const [loadingrequest , setLoadingRequest] = useState(false);

// const navigate = useNavigate();


  const checkAuth = async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/admin/check/acess`, {
        method: 'GET',
        credentials: 'include', 
      });

      if (!res.ok) throw new Error('Not authenticated');

      const data = await res.json();
      setUser(data.user); 
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };


  const login = async (credentials) => {

    setLoadingRequest(true);
 
    try {
      const res = await fetch(`${apiUrl}/auth/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          seckey:seckey,
        },
        credentials: 'include',
        body: JSON.stringify(credentials),
      });

         const data = await res.json();
         if(res.ok){

          toast.success(data.message)
          console.log(data);
          setEnterotp(true)
         }
         if(res.status === 400){
          toast.error(data.message)
         }

         if(res.status === 401){
          toast.error(data.message);
         }
       

       
       setLoadingRequest(false);


         if (res.status === 429) {
            alert(data.message);
            return;
          }

    
      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Login failed');
      }

      await checkAuth(); 
      return true;
    } catch (err) {
      throw err;
    }
  };



  const verifyLoginOTP = async (credentials)=>{

    try {
      const res = await fetch(`${apiUrl}/auth/admin/loginVerifyOtp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          seckey:seckey,
        },
         credentials: 'include',
        body: JSON.stringify(credentials),
      })


      // console.log(res);

      const data  = await  res.json();
  
      if(res.ok){
        toast.success(data.message);

      }else if(res.status === 404){
        toast.error(data.message);

      }else if(res.status === 401){
        toast.error(data.message)

      }else{
        toast.error("Server is Busy Try again later")
      }
       await checkAuth(); 

      
    } catch (error) {

      console.log('server fail  to verofy user try again', error);
      
    }
      //  setEnterotp(true)
  }



  const logout = async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/admin/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      if (res.ok) {
        setUser(null);
        localStorage.setItem("logout", Date.now());

      }
    } catch (err) {
      console.error('Logout failed:', err);
    }
            setEnterotp(false)

  };


  useEffect(() => {
    checkAuth();
  }, []);


  // Improve auth security of tab :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        setUser(null); 
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);





  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth , enterOtp, setEnterotp, verifyLoginOTP , loadingrequest}}>
      {children}
    </AuthContext.Provider>
  );
};
